import { API_ENDPOINT } from '@/configs';
import { API, AZURE_STORAGE_API } from '@/utils/api/api';

export const getDeviceInfoByAccessTokenApi = async (accessToken) => {
  return await API.get(`device/info/${accessToken}`);
};

export const defaultLoggerApi = async ({ type, logInfo }) => {
  return await API.post(`default/LogError`, { type, logInfo });
};

export const getDefaultTimeApi = async ({ timeZone }) => {
  return await API.get(API_ENDPOINT + `default/time/${timeZone}`);
};

export const getScheduledSlideApi = async ({ groupId, accessToken }) => {
  return await API.get(`schedule/GetSchedule/${groupId}/${accessToken}`);
};

export const getPlayerContentApi = async ({ file }) => {
  return await AZURE_STORAGE_API.get(`contents/${file}`);
};

export const syncProofToServerApi = async (formData) => {
  return await API.post('proof', formData);
};
